import { OrderSummaryLoader } from '../order-summary-loader/OrderSummaryLoader';
import { EllipsisMenu } from '../../ellipsis-menu/EllipsisMenu';
import { FrameRectangle } from '../frame-rectangle/FrameRectangle';
import styles from './GCOLoader.module.scss';

export const GCOLoader = () => (
  <div className={styles['gco-loader-wrapper']}>
    <div className={styles['gco-loader-container']}>
      <div className={styles['gco-loader-container-top']}>
        <div className={styles['gco-loader-container-top-section-1']}>
          <FrameRectangle height="48" borderRadius="8" width="146" />
          <EllipsisMenu data={[]} />
        </div>
        <div className={styles['gco-loader-container-top-section-2']}>
          <FrameRectangle height="48" borderRadius="8" />
        </div>
      </div>
      <FrameRectangle height="48" borderRadius="8" className={styles['gco-loader-container-mid-header']} />
      <div className={styles['gco-loader-container-middle']}>
        {[1, 2, 3].map((key) => (
          <div key={key} className={styles['gco-loader-container-middle-card']}>
            <FrameRectangle borderRadius="8" height="36" />
            <div className={styles['gco-loader-container-middle-card-mid']}>
              <FrameRectangle width="70" borderRadius="8" height="70" />
              <FrameRectangle width="70" borderRadius="8" height="70" />
              <FrameRectangle width="70" borderRadius="8" height="70" />
              <FrameRectangle width="70" borderRadius="8" height="70" />
            </div>
            <FrameRectangle borderRadius="8" height="36" />
          </div>
        ))}
      </div>
    </div>
    <OrderSummaryLoader className={styles['gco-loader-order-summary']} />
  </div>
);
